import {InlineOrderGuidDto, OrderGuidDto} from '@mybake/ui/models/Order/IOrderGuid';
import {useCurrency} from '../../../hooks/useCurrency';
import {orderAPI} from '../../../services/OrderServices';
import {OrderImageGallery} from './OrderImageGallery';
import {OrderDetailsViewGuid} from '@mybake/ui/components/orders/order/OrderDetailsViewGuid';

export const OrderDetailsContentGuid = ({inlineOrder, detailedOrder}: {inlineOrder: InlineOrderGuidDto; detailedOrder?: OrderGuidDto}) => {
    const {formatCurrency} = useCurrency();
    const {data: waste = []} = orderAPI.useGetOrderWasteV2Query(detailedOrder?.id ?? '', {skip: !detailedOrder});
    return <OrderDetailsViewGuid inlineOrder={inlineOrder} detailedOrder={detailedOrder} formatCurrency={formatCurrency} waste={waste}
        gallery={detailedOrder && <OrderImageGallery subOrders={detailedOrder.subOrders} contract="guid"/>}/>;
};
